<div class="modal-header">
  <h5 class="modal-title">
    {{ group.kind === 'handler' ? 'Handlers' : 'Price Lists' }} Requiring Update
  </h5>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="hint">Select the {{ group.itemLabel }}s you want to send a refresh request for.</p>

  <table class="table table-sm table-hover align-middle">
    <thead>
      <tr>
        <th class="col-check">
          <input type="checkbox" class="form-check-input" [checked]="allSelected"
            [indeterminate]="someSelected" (change)="toggleAll()" />
        </th>
        @if (group.kind === 'handler') { <th>Handler</th> }
        <th>Airport</th>
        <th>Status</th>
        <th>Valid until</th>
        <th>Last request</th>
      </tr>
    </thead>
    <tbody>
      @for (candidate of candidates; track candidate.id) {
        <tr [class.selected]="selected.has(candidate.id)"
          [class.disabled-row]="!candidate.recipientEmails.length"
          [title]="!candidate.recipientEmails.length ? 'No recipient email configured for this ' + group.itemLabel : ''"
          (click)="toggle(candidate)">
          <td class="col-check" (click)="$event.stopPropagation()">
            <input type="checkbox" class="form-check-input" [checked]="selected.has(candidate.id)"
              [disabled]="!candidate.recipientEmails.length" (change)="toggle(candidate)" />
          </td>
          @if (group.kind === 'handler') {
            <td><span class="item-name">{{ candidate.name }}</span></td>
          }
          <td>
            @if (candidate.airportIcao) {
              <span class="airport-icao">{{ candidate.airportIcao }}</span>
              <span class="airport-name">{{ candidate.airportName }}</span>
            } @else {
              <span class="text-muted">—</span>
            }
          </td>
          <td><span class="status-badge" [ngClass]="candidate.statusClass">{{ candidate.statusLabel }}</span></td>
          <td>{{ candidate.priceValidity ? (candidate.priceValidity | date:'dd MMM yyyy') : '—' }}</td>
          <td>{{ candidate.lastRequestSent ? (candidate.lastRequestSent | date:'dd MMM yyyy') : '—' }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="modal-footer">
  @if (confirming) {
    <div class="confirm-row w-100 d-flex align-items-center gap-2">
      <span class="confirm-text">Send requests to <strong>{{ selected.size }}</strong> {{ group.itemLabel }}(s)?</span>
      <button class="btn btn-blue btn-sm ms-auto" (click)="confirmSend()" [disabled]="sending">
        @if (sending) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Yes, send
      </button>
      <button class="btn btn-outline-secondary btn-sm" (click)="cancelConfirm()">Back</button>
    </div>
  } @else {
    <span class="selection-count">{{ selected.size }} of {{ candidates.length }} selected</span>
    <button class="btn btn-blue btn-sm ms-auto" (click)="send()" [disabled]="sending || selected.size === 0">Send Request</button>
    <button class="btn btn-outline-secondary btn-sm" (click)="close()">Cancel</button>
  }
</div>
